<template>
  <div>
    <div class="list-item">
      <div class="imgbox">
        <img src="https://cunw-edu-res-test.oss-cn-hangzhou.aliyuncs.com/cloud/edu/courseware/thumb/20210108/797155673937940480.jpg?Expires=1620441134&OSSAccessKeyId=LTAI4FruwZcrEuuy99M7bH43&Signature=Ard%2BIwHStjKnVvgbjtEJHkwV7UA%3D" class="imgsrc">
      </div>
      <div class="text">
        <div class="title">
          应用名称  <span class="dwon">下载次数：3092</span> <span class="right">
            <el-button type="primary" size="medium">添加应用</el-button>
            <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="handlerLink">返回</el-button>
          </span>
        </div>
        <p>适用年级：二年级</p>
        <p>适用学科：数学 </p>
        <p>更新时间：2020-01-15</p>
        <div class="updateDec">
          更新描述：
        </div>
        <div class="decDetail">
          <p>1.新增XX功能</p>
          <p>2.新增支持XX</p>
          <p> 3.修复多个已知BUG</p>
        </div>
      </div>
    </div>
    <div class="dec">
      一句话介绍应用，一句话介绍应用默认展示40个文字，超出以省略号表示超出以省略号表示……
    </div>
    <module-title title="特色资源" class="module-title" />
    <div>
      图文混排介绍，对应用的使用方式意义呢进行阐述说明，内容通过后台录入或编辑
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppDetail',
  props: {
    propsObj: {
      default: Object,
      type: Object
    }
  },
  data: () => {
    return {
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    handlerLink() {
      this.$router.push('/' + this.propsObj.link + '/' + this.propsObj.propsId);
    }
  }
};
</script>
<style scoped lang="scss">
  .list-item {
    display: flex;
    .imgbox {
      width: 210px;
      height: 210px;
      border: 1px solid #999;
      .imgsrc {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      flex: 1;
      margin-left: 20px;
      line-height: 30px;
      .title{
        font-size: 16px;
        font-weight: bold;
      }
      .updateDec{
        display: inline-block;
        vertical-align: top;
      }
      .decDetail{
        display: inline-block;
        line-height: 24px;
      }
    }
  }
  .dec{
    margin-top: 20px;
     margin-bottom: 40px;
  }
</style>

